var ShippingMethod;
(function(ShippingMethod) {
    ShippingMethod["Delivery"] = 'home-delivery';
    ShippingMethod["DeliveryExpress"] = 'home-delivery-express';
    ShippingMethod["NearestPickup"] = 'nearest-pick-up';
    ShippingMethod["Pickup"] = 'pick-up';
    ShippingMethod["PickupPoint"] = 'pick-up-point';
    ShippingMethod["DeliveryPremium"] = 'dpd-priority-delivery';
})(ShippingMethod || (ShippingMethod = {}));

export { ShippingMethod };
//# sourceMappingURL=shipping-methods.js.map
